var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-lg" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-12 col-md-6 mt-3" }, [
        _c(
          "div",
          {
            staticClass: "card",
            staticStyle: { cursor: "pointer" },
            attrs: { id: "loginUser" },
            on: {
              click: function ($event) {
                return _vm.PushTo("/signin")
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "card-body text-center" },
              [
                _c("font-awesome-icon", {
                  staticClass: "fa-5x",
                  staticStyle: { color: "#198fcf" },
                  attrs: { icon: ["fas", "right-from-bracket"] },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [
              _vm._v("Bin schon dabei - lasst mich rein!"),
            ]),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-12 col-md-6 mt-3" }, [
        _c(
          "div",
          {
            staticClass: "card",
            staticStyle: { cursor: "pointer" },
            attrs: { id: "addUser" },
            on: {
              click: function ($event) {
                return _vm.PushTo("/signup")
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "card-body text-center" },
              [
                _c("font-awesome-icon", {
                  staticClass: "fa-5x",
                  staticStyle: { color: "#198fcf" },
                  attrs: { icon: ["fas", "user-plus"] },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [_vm._v("Ich bin neu!")]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      false
        ? _c("div", { staticClass: "col-sm-12 col-md-6 mt-3" }, [
            _c("div", { staticClass: "card" }, [
              _c(
                "div",
                {
                  staticClass: "card-body text-center",
                  staticStyle: { cursor: "pointer" },
                  on: {
                    click: function ($event) {
                      return _vm.PushTo("/companySignin")
                    },
                  },
                },
                [
                  _c("font-awesome-icon", {
                    staticClass: "fa-5x",
                    staticStyle: { color: "#bc0101" },
                    attrs: { icon: ["fas", "building-circle-arrow-right"] },
                  }),
                  _vm._v(" "),
                  _c("fa", {
                    staticClass: "fa-5x",
                    staticStyle: { color: "#bc0101" },
                    attrs: { icon: "building" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "text-center" }, [
                _vm._v("Anmeldung Firmen"),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      false
        ? _c("div", { staticClass: "col-sm-12 col-md-6 mt-3" }, [
            _c(
              "div",
              {
                staticClass: "card",
                staticStyle: { cursor: "pointer" },
                on: {
                  click: function ($event) {
                    return _vm.PushTo("/companySignUp")
                  },
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "card-body text-center" },
                  [
                    _c("font-awesome-icon", {
                      staticClass: "fa-5x",
                      staticStyle: { color: "#bc0101" },
                      attrs: { icon: ["fas", "fa-plus"] },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "text-center" }, [
                  _vm._v("Wir sind neu!"),
                ]),
              ]
            ),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm._m(1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 mt-3" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("h2", [
              _vm._v("Finde deine perfekte Ausbildung – mit KI-Unterstützung."),
            ]),
            _vm._v(" "),
            _c("h3", [
              _vm._v("Du hast viele Fragen. Wir haben die Antworten."),
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n            Welcher Beruf passt wirklich zu dir? Was macht dir Spaß? Wo kannst\n            du deine Stärken einsetzen? Unsere App hilft dir, diese Fragen zu\n            beantworten – ehrlich, individuell und ohne Druck.\n          "
              ),
            ]),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-12 mt-3" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("h3", [_vm._v("So funktioniert’s:")]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("ol", [
              _c("li", [
                _vm._v("\n              48 einfache Fragen.\n              "),
                _c("br"),
                _vm._v(
                  "\n              Keine falschen Antworten – nur ehrliche Einblicke in deine\n              Persönlichkeit.\n            "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n              Intelligente Auswertung\n              "
                ),
                _c("br"),
                _vm._v(
                  "\n              Unsere KI analysiert deine Antworten und erkennt, welche Berufe\n              wirklich zu dir passen.\n            "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "\n              Individuelle Empfehlungen\n              "
                ),
                _c("br"),
                _vm._v(
                  "\n              Du erhältst eine Liste passender Ausbildungsberufe – abgestimmt\n              auf deine Interessen, Stärken und Werte.\n            "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v("\n              Berufe entdecken\n              "),
                _c("br"),
                _vm._v(
                  "\n              Tauche in spannende Berufswelten ein, die du vielleicht noch gar\n              nicht auf dem Schirm hattest – aber perfekt zu dir passen.\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h3", [_vm._v("Warum unsere App?")]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _c("b", [_vm._v("Persönlich:")]),
                _vm._v(
                  " Du stehst im Mittelpunkt – nicht deine Noten.\n            "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _c("b", [_vm._v("Einfach:")]),
                _vm._v(
                  " Kein komplizter Test, sondern ein Gespräch über\n              dich.\n            "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _c("b", [_vm._v("Zukunftssicher:")]),
                _vm._v(
                  " Mit KI-Technologie entwickelst du deinen\n              eigenen Karriereweg.\n            "
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _c("b", [_vm._v("Inspirierend:")]),
                _vm._v(
                  " Entdecke Ausbildungsberufe, die zu dir UND\n              deiner Zukunft passen.\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("h3", [_vm._v("Starte jetzt - kostenlos und anonym")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n            Mach den ersten Schritt in deine berufliche Zukunft. Finde heraus,\n            was wirklich zu dir passt – ganz ohne Druck, ohne Bewerbung und\n            ohne Erwartungen.\n          "
              ),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }